var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWlb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 26,
    viewBox: "0 0 107 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#014a62}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410-2",
    "data-name": "Group 410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    d: "M420.673 793.947c-2.738 3.908-10.673 6.364-15.757 3.294l-.192-.118a11.493 11.493 0 0 1-4.875-6.089l-.026-.2-.1-.752s-.443-2.474-1.028-4.9l-.257-1.393a3.215 3.215 0 0 1-.084-.4 3.616 3.616 0 0 1 .17-1.876 3.378 3.378 0 0 1 1.854-1.6h.01a4.451 4.451 0 0 1 1.4-.241h.009a3.127 3.127 0 0 1 2.544 1.257 4.087 4.087 0 0 1 .524 1.391s.136.529.32 1.233a94.848 94.848 0 0 0 1.191 5.148l.223.726.053.169.227.724s.782 2.177 4.023 2.01a4.64 4.64 0 0 0 4.414-2.9 5.937 5.937 0 0 0-.056-2.568l-1.173-5.694s-.783-2.959.894-4.3 4.917-1.061 5.643 1.4 1.509 6.922 1.509 6.922 1.278 4.849-1.46 8.757z",
    className: "cls-1",
    "data-name": "Path 364",
    transform: "translate(-382.317 -776.069)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    d: "M151.348 854.687l-.074.11c-3.326 4.906-11.579 5.983-15.721 3.577s-5.025-7.35-5.025-7.35-1.176-4.38-1.553-6.912 2.451-4.137 4.542-3.619 2.63 3.529 2.63 3.529l1.34 5.658a5.944 5.944 0 0 0 1.035 2.354 4.676 4.676 0 0 0 5.241.8c3.018-1.2 2.809-3.5 2.809-3.5l-.1-.73-.026-.2-.1-.752s-.443-2.474-1.028-4.9l-.257-1.393a3.21 3.21 0 0 1-.084-.4 3.615 3.615 0 0 1 .17-1.875 3.378 3.378 0 0 1 1.854-1.6h.01a4.447 4.447 0 0 1 1.4-.241h.008a3.127 3.127 0 0 1 2.543 1.257 4.088 4.088 0 0 1 .524 1.39s.136.529.32 1.233a94.848 94.848 0 0 0 1.191 5.148l.223.726.053.169a11.419 11.419 0 0 1-1.925 7.521z",
    className: "cls-1",
    "data-name": "Path 365",
    transform: "translate(-128.94 -833.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    d: "M402.122 842.8a3.115 3.115 0 0 1-3.772-1.817 3.671 3.671 0 0 1 .17-1.89 3.385 3.385 0 0 1 1.854-1.612h.01a3.853 3.853 0 0 1 .493-.147 3.814 3.814 0 0 1 .906-.1h.009a3.12 3.12 0 0 1 2.544 1.267 2.419 2.419 0 0 1 .313.644c.02.062.038.126.052.192a3.072 3.072 0 0 1-2.579 3.463z",
    className: "cls-1",
    "data-name": "Path 366",
    transform: "translate(-382.317 -833.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(46.514 1.986)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    d: "M906.981 808.543l-3.358 9.92h-.765l-3.075-8.9-3.089 8.9h-.765l-3.373-9.92h.765l3.018 8.928 3.1-8.928h.694l3.089 8.942 3.047-8.942z",
    className: "cls-1",
    "data-name": "Path 367",
    transform: "translate(-892.555 -807.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    d: "M1138.936 853.858a3.521 3.521 0 1 1 3.514 3.755 3.519 3.519 0 0 1-3.514-3.755zm6.341 0a2.841 2.841 0 1 0-2.827 3.118 2.87 2.87 0 0 0 2.826-3.118z",
    className: "cls-1",
    "data-name": "Path 368",
    transform: "translate(-1124.632 -846.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    d: "M1289.4 850.1v.694c-.073 0-.147-.014-.221-.014-2.137 0-3.408 1.091-3.408 2.919v3.854h-.921v-7.4h.884v1.615c.587-1.068 1.858-1.668 3.666-1.668z",
    className: "cls-1",
    "data-name": "Path 369",
    transform: "translate(-1262.046 -846.985)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    d: "M1357.792 805.073l-2.139 1.757v2.2h-.786v-10.518h.786v7.44l5.254-4.322h1.007l-3.539 2.99 3.885 4.407h-.975z",
    className: "cls-1",
    "data-name": "Path 370",
    transform: "translate(-1328.03 -798.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    d: "M1475.6 808.543h.831v9.268H1483v.652h-7.4z",
    className: "cls-1",
    "data-name": "Path 371",
    transform: "translate(-1441.756 -807.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    d: "M1599.2 805.991a.553.553 0 0 1 1.105 0 .553.553 0 1 1-1.105 0zm.2 2.154h.708v7.4h-.708z",
    className: "cls-1",
    "data-name": "Path 372",
    transform: "translate(-1558.073 -804.97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    d: "M1619.407 799.653v1.077h2.366v.609h-2.352v6.788h-.708v-6.787h-1.36v-.609h1.36V799.6a1.888 1.888 0 0 1 2.055-2.041 2.211 2.211 0 0 1 1.459.482l-.283.539a1.7 1.7 0 0 0-1.148-.411c-.922-.004-1.389.507-1.389 1.484z",
    className: "cls-1",
    "data-name": "Path 373",
    transform: "translate(-1575.348 -797.556)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    d: "M1678.656 854.028h-6.617a3.05 3.05 0 0 0 3.257 2.948 3.159 3.159 0 0 0 2.461-1.034l.427.468a3.75 3.75 0 0 1-2.9 1.2 3.708 3.708 0 0 1-3.964-3.755 3.678 3.678 0 1 1 7.354-.028c-.003.06-.018.13-.018.201zm-6.6-.553h5.895a2.955 2.955 0 0 0-5.895 0z",
    className: "cls-1",
    "data-name": "Path 374",
    transform: "translate(-1626.111 -846.985)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    transform: "translate(.19 9.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    d: "M904.5 999.089l-1.5-1.417a5 5 0 0 1-3.615 1.346c-2.116 0-3.63-1.02-3.63-2.522 0-1.176.741-2.041 2.719-3.089-1.05-.992-1.359-1.587-1.359-2.352 0-1.261 1.066-2.111 2.734-2.111 1.529 0 2.518.737 2.518 1.97 0 .992-.649 1.686-2.41 2.622l2.966 2.806a5.863 5.863 0 0 0 .726-1.913l.9.255a6.464 6.464 0 0 1-.958 2.282l1.545 1.459zm-2.147-2.026l-3.259-3.075c-1.73.907-2.255 1.531-2.255 2.409 0 1.077 1.05 1.785 2.61 1.785a3.927 3.927 0 0 0 2.905-1.119zm-4.217-6.023c0 .581.232.992 1.22 1.913 1.56-.822 2.07-1.318 2.07-2.026 0-.737-.572-1.233-1.576-1.233-1.08 0-1.713.553-1.713 1.346z",
    className: "cls-1",
    "data-name": "Path 375",
    transform: "translate(-895.758 -988.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    d: "M1075.415 997.365c0 1.7-1.439 2.693-4.193 2.693h-5.322v-9.92h5.02c2.571 0 3.949 1.006 3.949 2.579a2.359 2.359 0 0 1-1.377 2.182 2.472 2.472 0 0 1 1.923 2.466zm-7.53-5.782v2.735h2.816c1.377 0 2.158-.454 2.158-1.361s-.781-1.375-2.158-1.375zm5.525 5.6c0-.992-.811-1.431-2.311-1.431h-3.214v2.863h3.214c1.501-.003 2.311-.442 2.311-1.434z",
    className: "cls-1",
    "data-name": "Path 376",
    transform: "translate(-1055.996 -989.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    d: "M1237.582 1032.788h-6.531a2.492 2.492 0 0 0 2.7 1.814 3.143 3.143 0 0 0 2.26-.822l1.044 1.091a4.436 4.436 0 0 1-3.351 1.233c-2.79 0-4.6-1.63-4.6-3.883s1.824-3.869 4.3-3.869a3.881 3.881 0 0 1 4.209 3.911c0 .143-.013.355-.031.525zm-6.547-1.176h4.723a2.207 2.207 0 0 0-2.354-1.842 2.243 2.243 0 0 0-2.369 1.842z",
    className: "cls-1",
    "data-name": "Path 377",
    transform: "translate(-1209.699 -1025.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    d: "M1367.784 1029.785l-3.543 8.177c-.694 1.715-1.658 2.239-2.919 2.239a3.132 3.132 0 0 1-2.026-.694l.708-1.3a1.92 1.92 0 0 0 1.3.524c.624 0 .992-.3 1.332-1.049l.128-.3-3.3-7.6h1.842l2.381 5.6 2.395-5.6z",
    className: "cls-1",
    "data-name": "Path 378",
    transform: "translate(-1332.314 -1026.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    d: "M1494.137 1032.222c0-2.267 1.9-3.869 4.507-3.869 2.635 0 4.523 1.6 4.523 3.869s-1.889 3.883-4.523 3.883c-2.603-.005-4.507-1.616-4.507-3.883zm7.031 0a2.52 2.52 0 1 0-2.524 2.366 2.336 2.336 0 0 0 2.524-2.366z",
    className: "cls-1",
    "data-name": "Path 379",
    transform: "translate(-1459.313 -1025.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    d: "M1664.022 1031.669v4.336h-1.771v-4.105c0-1.346-.666-2-1.8-2a2.01 2.01 0 0 0-2.111 2.281v3.826h-1.771v-7.567h1.686v.978a3.291 3.291 0 0 1 2.607-1.063 2.957 2.957 0 0 1 3.16 3.314z",
    className: "cls-1",
    "data-name": "Path 380",
    transform: "translate(-1612.427 -1025.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_381",
    d: "M1801.461 980.106v10.515h-1.7v-.978a3.12 3.12 0 0 1-2.508 1.077 3.876 3.876 0 0 1 0-7.751 3.1 3.1 0 0 1 2.438 1.02v-3.883zm-1.743 6.731a2.256 2.256 0 1 0-2.253 2.367 2.212 2.212 0 0 0 2.253-2.367z",
    className: "cls-1",
    "data-name": "Path 381",
    transform: "translate(-1741.165 -980.106)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWlb);
export default __webpack_public_path__ + "static/media/logo-wlb.c58baa9b0dd3dbc8c39d9fb2d3cdedef.svg";
export { ForwardRef as ReactComponent };